import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from "@/views/Home/HomeView";
import ProfileEdit from "@/views/Profile/ProfileEdit.vue";
import LoginView from "@/views/Auth/LoginView";
import FileManager from "@/views/FileManager/FileManager";
import UploadFile from "@/views/FileManager/UploadFile";
import StudentIndex from "@/views/Student/StudentIndex";
import StudentCreate from "@/views/Student/StudentCreate";
import StudentEdit from "@/views/Student/StudentEdit";
import StudentSetting from "@/views/Student/StudentSetting";
import TeacherIndex from "@/views/Teacher/TeacherIndex";
import TeacherCreate from "@/views/Teacher/TeacherCreate";
import TeacherEdit from "@/views/Teacher/TeacherEdit";
import TeacherSetting from "@/views/Teacher/TeacherSetting";
import CourseIndex from "@/views/Course/CourseIndex";
import CourseCreate from "@/views/Course/CourseCreate";
import CourseEdit from "@/views/Course/CourseEdit";
import CourseSetting from "@/views/Course/CourseSetting";
import OnlineClassIndex from "@/views/OnlineClass/OnlineClassIndex";
import OnlineClassCreate from "@/views/OnlineClass/OnlineClassCreate";
import OnlineClassEdit from "@/views/OnlineClass/OnlineClassEdit";
import OnlineClassSetting from "@/views/OnlineClass/OnlineClassSetting";
import ItemSetting from "@/views/Item/ItemSetting";
import ItemEdit from "@/views/Item/ItemEdit";
import ItemCreate from "@/views/Item/ItemCreate";
import ItemIndex from "@/views/Item/ItemIndex";
import ItemFileIndex from "@/views/ItemFile/ItemFileIndex";
import ItemFileCreate from "@/views/ItemFile/ItemFileCreate";
import ItemFileEdit from "@/views/ItemFile/ItemFileEdit";
import ItemFileSetting from "@/views/ItemFile/ItemFileSetting";
import CourseItemRelations from "@/views/Course/CourseItemRelations";
import CourseItemOrder from "@/views/Course/CourseItemOrder";
import ItemFileRelations from "@/views/Item/ItemFileRelations";
import ItemFileOrder from "@/views/Item/ItemFileOrder";
import ActivityTagIndex from "@/views/ActivityTag/ActivityTagIndex.vue";
import NotificationIndex from "@/views/Notification/NotificationIndex";
import NotificationMy from "@/views/Notification/NotificationMy";
import NotificationCreate from "@/views/Notification/NotificationCreate";
import NotificationEdit from "@/views/Notification/NotificationEdit";
import NotificationSetting from "@/views/Notification/NotificationSetting";
import MessageIndex from "@/views/Message/MessageIndex";
import MessageCreate from "@/views/Message/MessageCreate";
import MessageEdit from "@/views/Message/MessageEdit";
import MessageSetting from "@/views/Message/MessageSetting";
import TicketIndex from "@/views/Ticket/TicketIndex";
import TicketEdit from "@/views/Ticket/TicketEdit";
import TicketSetting from "@/views/Ticket/TicketSetting";
import MessageReply from "@/views/Message/MessageReply";
import TicketReply from "@/views/Ticket/TicketReply";
import OnlineSessionIndex from "@/views/OnlineSession/OnlineSessionIndex";
import PrivateOnlineSessionIndex from "@/views/PrivateOnlineClass/PrivateOnlineSessionIndex.vue"
import PrivateOnlineSessionCreate from "@/views/PrivateOnlineClass/PrivateOnlineSessionCreate.vue"
import PrivateOnlineSessionEdit from "@/views/PrivateOnlineClass/PrivateOnlineSessionEdit.vue"
import OnlineSessionCreate from "@/views/OnlineSession/OnlineSessionCreate";
import OnlineSessionEdit from "@/views/OnlineSession/OnlineSessionEdit";
import OnlineSessionSetting from "@/views/OnlineSession/OnlineSessionSetting";
import OnlineClassManageIndex from "@/views/OnlineClass/Manage/OnlineClassManageIndex";
import OnlineClassManageStudents from "@/views/OnlineClass/Manage/OnlineClassManageStudents";
import OnlineClassManageSetting from "@/views/OnlineClass/Manage/OnlineClassManageSetting";
import OnlineClassItem from "@/views/OnlineClass/Manage/OnlineClassItem";
import OnlineSessionMeeting from "@/views/OnlineSession/Meeting/OnlineSessionMeeting";
import RoleIndexView from "@/views/Permission/Role/RoleIndexView";
import RoleCreateView from "@/views/Permission/Role/RoleCreateView";
import RoleEditView from "@/views/Permission/Role/RoleEditView";
import RoleSettingView from "@/views/Permission/Role/RoleSettingView";
import MyOnlineClassesIndex from "@/views/OnlineClass/MyOnlineClassesIndex";
import CategoryIndexView from "@/views/Category/CategoryIndexView";
import CategoryEditView from "@/views/Category/CategoryEditView";
import CategoryCreateView from "@/views/Category/CategoryCreateView";
import CategorySettingView from "@/views/Category/CategorySettingView";
import SystemIndexView from "@/views/System/SystemIndexView";
import CoverIndexView from "@/views/Cover/CoverIndexView.vue";
import CoverCreateView from "@/views/Cover/CoverCreateView.vue";
import CoverEditView from "@/views/Cover/CoverEditView.vue";
import ShowFile from "@/views/ShowFile/ShowFile.vue";
import SchoolIndexView from "@/views/School/SchoolIndexView.vue";
import SchoolCreateView from "@/views/School/SchoolCreateView.vue";
import SchoolEditView from "@/views/School/SchoolEditView.vue";
import SmsIndex from "@/views/Sms/SmsIndex.vue";
import SmsEditView from "@/views/Sms/SmsEditView.vue";
import SmsGetView from "@/views/Sms/SmsGetView.vue";
import OtpIndex from "@/views/Otp/OtpIndex.vue";
import ActivityIndex from "@/views/Activity/ActivityIndex.vue";
import DictationIndex from "@/views/Dictation/DictationIndex.vue";
import DictationCreate from "@/views/Dictation/DictationCreate.vue";
import DictationEdit from "@/views/Dictation/DictationEdit.vue";
import AlphabetDictationIndex from "@/views/AlphabetDictation/AlphabetDictationIndex.vue";
import AlphabetDictationCreate from "@/views/AlphabetDictation/AlphabetDictationCreate.vue";
import AlphabetDictationEdit from "@/views/AlphabetDictation/AlphabetDictationEdit.vue";
import OnlineClassDictation from "@/views/OnlineClass/Manage/OnlineClassDictation.vue";
import OnlineClassDictationV2 from "@/views/OnlineClass/Manage/OnlineClassDictationV2.vue";
import TransactionIndexView from "@/views/Transaction/TransactionIndexView.vue";
import SubscriptionIndexView from "@/views/Subscription/SubscriptionIndexView.vue";
import SubscriptionEditView from "@/views/Subscription/SubscriptionEditView.vue";
import SubscriptionCreateView from "@/views/Subscription/SubscriptionCreateView.vue";
import TestView from "@/views/Test/TestView.vue";
import TransactionAnalysisView from "@/views/Transaction/TransactionAnalysisView.vue";
import StudentGet from "@/views/Student/StudentGet.vue";
import LogIndexView from "@/views/Log/LogIndexView.vue";
import MachineTuningIndex from "@/views/MachineLearning/MachineTuningIndex.vue";
import MusicPieceBuilder from "@/views/MachineLearning/MusicPieceBuilder.vue";
import EffortCalendar from "@/views/Assessment/EffortCalendar.vue";
import SocialNetworkAdmin from "@/views/Social/SocialNetworkAdmin.vue";


Vue.use(VueRouter)

const routes = [
    /*HOME*/
    {
        path: '/',
        name: 'home',
        component: HomeView
    },
    {
        path: '/test',
        name: 'test',
        component: TestView
    },
    /*LOGIN*/
    {
        path: '/login',
        name: 'login',
        component: LoginView
    },
    /*PROFILE*/
    {
        path: '/profile',
        name: 'profile',
        component: ProfileEdit
    },
    /*Permissions*/
    {
        path: '/permission-and-role/role/index',
        name: 'RoleIndexView',
        component: RoleIndexView
    },
    {
        path: '/permission-and-role/role/create',
        name: 'RoleCreateView',
        component: RoleCreateView
    },
    {
        path: '/permission-and-role/role/edit/:id',
        name: 'RoleEditView',
        component: RoleEditView
    },
    {
        path: '/permission-and-role/role/setting',
        name: 'RoleSettingView',
        component: RoleSettingView
    },
    /*FILEMANAGER*/
    {
        path: '/file-manager/index',
        name: 'FileManager',
        component: FileManager
    },
    {
        path: '/file-manager/store',
        name: 'UploadFile',
        component: UploadFile
    },

    /*SCHOOLS*/

    {
        path: '/school/index',
        name: 'SchoolIndexView',
        component: SchoolIndexView
    },
    {
        path: '/school/edit/:id',
        name: 'SchoolEditView',
        component: SchoolEditView
    },
    {
        path: '/school/create',
        name: 'SchoolCreateView',
        component: SchoolCreateView
    },

    /*SCHOOLS*/

    {
        path: '/subscription/index',
        name: 'SubscriptionIndexView',
        component: SubscriptionIndexView
    },
    {
        path: '/subscription/edit/:id',
        name: 'SubscriptionEditView',
        component: SubscriptionEditView
    },
    {
        path: '/subscription/create',
        name: 'SubscriptionCreateView',
        component: SubscriptionCreateView
    },


    {
        path: '/logs/index',
        name: 'LogIndexView',
        component: LogIndexView
    },

    /*STUDENTS*/
    {
        path: '/students/index',
        name: 'StudentIndex',
        component: StudentIndex
    },
    {
        path: '/students/create',
        name: 'StudentCreate',
        component: StudentCreate
    },
    {
        path: '/students/edit/:id',
        name: 'StudentEdit',
        component: StudentEdit
    },
    {
        path: '/students/get/:id',
        name: 'StudentGet',
        component: StudentGet
    },
    {
        path: '/students/setting',
        name: 'StudentSetting',
        component: StudentSetting
    },
    /*TEACHERS*/
    {
        path: '/teachers/index',
        name: 'TeacherIndex',
        component: TeacherIndex
    },
    {
        path: '/teachers/create',
        name: 'TeacherCreate',
        component: TeacherCreate
    },
    {
        path: '/teachers/edit/:id',
        name: 'TeacherEdit',
        component: TeacherEdit
    },
    {
        path: '/teachers/setting',
        name: 'TeacherSetting',
        component: TeacherSetting
    },

    /*COURSES*/
    {
        path: '/courses/index',
        name: 'CourseIndex',
        component: CourseIndex
    },
    {
        path: '/courses/items/assign/:id',
        name: 'CourseItemRelations',
        component: CourseItemRelations
    },
    {
        path: '/courses/items/order/:id',
        name: 'CourseItemOrder',
        component: CourseItemOrder
    },
    {
        path: '/courses/create',
        name: 'CourseCreate',
        component: CourseCreate
    },
    {
        path: '/courses/edit/:id',
        name: 'CourseEdit',
        component: CourseEdit
    },
    {
        path: '/courses/setting',
        name: 'CourseSetting',
        component: CourseSetting
    },

    /*CLASSES*/
    {
        path: '/classes/my/index',
        name: 'MyOnlineClasses',
        component: MyOnlineClassesIndex
    },
    {
        path: '/classes/index',
        name: 'OnlineClassIndex',
        component: OnlineClassIndex
    },
    {
        path: '/classes/online/index',
        name: 'PrivateOnlineSessionIndex',
        component: PrivateOnlineSessionIndex
    },
    {
        path: '/classes/online/create',
        name: 'PrivateOnlineSessionCreate',
        component: PrivateOnlineSessionCreate
    },
    {
        path: '/classes/online/edit/:id',
        name: 'PrivateOnlineSessionEdit',
        component: PrivateOnlineSessionEdit
    },

    {
        path: '/classes/create',
        name: 'OnlineClassCreate',
        component: OnlineClassCreate
    },
    {
        path: '/classes/edit/:id',
        name: 'OnlineClassEdit',
        component: OnlineClassEdit
    },
    {
        path: '/classes/setting',
        name: 'OnlineClassSetting',
        component: OnlineClassSetting
    },
    {
        path: '/classes/manage/index/:id/:studentId',
        name: 'OnlineClassManageIndex',
        component: OnlineClassManageIndex
    },
    {
        path: '/classes/manage/students/:id',
        name: 'OnlineClassManageStudents',
        component: OnlineClassManageStudents
    },
    {
        path: '/classes/manage/setting/:id',
        name: 'OnlineClassManageSetting',
        component: OnlineClassManageSetting
    },
    {
        path: '/classes/manage/item/show/:classId/:itemId/:studentId',
        name: 'OnlineClassItem',
        component: OnlineClassItem
    },

    {
        path: '/classes/manage/dictation/show/:classId/:itemId/:dictationId/:studentId',
        name: 'OnlineClassDictation',
        component: OnlineClassDictation
    },
    {
        path: '/classes/manage/dictation/single/show/:classId/:dictationId/:studentId',
        name: 'OnlineClassDictationV2',
        component: OnlineClassDictationV2
    },
    /*SESSIONS*/
    {
        path: '/classes/sessions/index/:classId',
        name: 'OnlineSessionIndex',
        component: OnlineSessionIndex
    },
    {
        path: '/classes/sessions/create/:classId',
        name: 'OnlineSessionCreate',
        component: OnlineSessionCreate
    },
    {
        path: '/classes/sessions/edit/:classId/:sessionId',
        name: 'OnlineSessionEdit',
        component: OnlineSessionEdit
    },
    {
        path: '/classes/sessions/setting/:classId',
        name: 'OnlineSessionSetting',
        component: OnlineSessionSetting
    },
    {
        path: '/classes/sessions/meeting/:classId/:meetingId/:instructorId',
        name: 'OnlineSessionMeeting',
        component: OnlineSessionMeeting
    },


    /*Transactions*/
    {
        path: '/transaction/index',
        name: 'TransactionIndexView',
        component: TransactionIndexView
    },

    {
        path: '/transaction/analysis',
        name: 'TransactionAnalysisView',
        component: TransactionAnalysisView
    },

    /*COVERS*/
    {
        path: '/cover/index',
        name: 'CoverIndexView',
        component: CoverIndexView
    },
    {
        path: '/cover/create',
        name: 'CoverCreateView',
        component: CoverCreateView
    },
    {
        path: '/cover/edit/:coverId',
        name: 'CoverEditView',
        component: CoverEditView
    },

    /*ITEMS*/
    {
        path: '/items/index',
        name: 'ItemIndex',
        component: ItemIndex
    },
    {
        path: '/items/item-files/assign/:id',
        name: 'ItemFileRelations',
        component: ItemFileRelations
    },
    {
        path: '/items/item-files/order/:id',
        name: 'ItemFileOrder',
        component: ItemFileOrder
    },
    {
        path: '/items/create',
        name: 'ItemCreate',
        component: ItemCreate
    },
    {
        path: '/items/edit/:id',
        name: 'ItemEdit',
        component: ItemEdit
    },
    {
        path: '/items/setting',
        name: 'ItemSetting',
        component: ItemSetting
    },
    {
        path: '/activity-tags/index',
        name: 'ActivityTagIndex',
        component: ActivityTagIndex
    },
    {
        path: '/effort-calendar',
        name: 'EffortCalendar',
        component: EffortCalendar
    },
    { path: '/social-network', name: 'SocialNetworkAdmin', component: SocialNetworkAdmin },

    /*ITEM FILES*/
    {
        path: '/item-files/index',
        name: 'ItemFileIndex',
        component: ItemFileIndex
    },
    {
        path: '/item-files/create',
        name: 'ItemFileCreate',
        component: ItemFileCreate
    },
    {
        path: '/item-files/edit/:id',
        name: 'ItemFileEdit',
        component: ItemFileEdit
    },
    {
        path: '/item-files/setting',
        name: 'ItemFileSetting',
        component: ItemFileSetting
    },

    /*Notifications*/
    {
        path: '/notifications/my',
        name: 'NotificationMy',
        component: NotificationMy
    },
    {
        path: '/notifications/index',
        name: 'NotificationIndex',
        component: NotificationIndex
    },
    {
        path: '/notifications/create',
        name: 'NotificationCreate',
        component: NotificationCreate
    },
    {
        path: '/notifications/edit/:id',
        name: 'ItemEdit',
        component: NotificationEdit
    },
    {
        path: '/notifications/setting',
        name: 'ItemSetting',
        component: NotificationSetting
    },


    /*Messages*/
    {
        path: '/messages/index',
        name: 'MessageIndex',
        component: MessageIndex
    },
    {
        path: '/messages/create',
        name: 'MessageCreate',
        component: MessageCreate
    },
    {
        path: '/messages/reply/:id',
        name: 'MessageReply',
        component: MessageReply
    },
    {
        path: '/messages/edit/:id',
        name: 'MessageEdit',
        component: MessageEdit
    },
    {
        path: '/messages/setting',
        name: 'MessageSetting',
        component: MessageSetting
    },

    /*Tickets*/
    {
        path: '/tickets/index',
        name: 'TicketIndex',
        component: TicketIndex
    },
    {
        path: '/tickets/reply/:id',
        name: 'TicketReply',
        component: TicketReply
    },
    {
        path: '/tickets/edit/:id',
        name: 'TicketEdit',
        component: TicketEdit
    },
    {
        path: '/tickets/setting',
        name: 'TicketSetting',
        component: TicketSetting
    },


    /*Setting's*/
    {
        path: '/setting/category/index',
        name: 'CategoryIndexView',
        component: CategoryIndexView
    },
    {
        path: '/setting/category/edit/:id',
        name: 'CategoryEditView',
        component: CategoryEditView
    },
    {
        path: '/setting/category/create',
        name: 'CategoryCreateView',
        component: CategoryCreateView
    },
    {
        path: '/setting/category/setting',
        name: 'CategorySettingView',
        component: CategorySettingView
    },


    {
        path: '/setting/system/index',
        name: 'SystemIndexView',
        component: SystemIndexView
    },


    {
        path: '/file/show/:id',
        name: 'ShowFile',
        component: ShowFile
    },


    {
        path: '/sms/index',
        name: 'SmsIndex',
        component: SmsIndex
    },
    {
        path: '/sms/edit/:id',
        name: 'SmsEditView',
        component: SmsEditView
    },
    {
        path: '/sms/get/:id',
        name: 'SmsGetView',
        component: SmsGetView
    },

    {
        path: '/otp/index',
        name: 'OtpIndex',
        component: OtpIndex
    },
    {
        path: '/activities/index',
        name: 'ActivityIndex',
        component: ActivityIndex
    },

    {
        path: '/dictation/index',
        name: 'DictationIndex',
        component: DictationIndex
    },
    {
        path: '/dictation/create',
        name: 'DictationCreate',
        component: DictationCreate
    },
    {
        path: '/dictation/copy/:id',
        name: 'DictationCopy',
        component: DictationCreate
    },
    {
        path: '/dictation/edit/:id',
        name: 'DictationEdit',
        component: DictationEdit
    },


    {
        path: '/dictation/alphabet/index',
        name: 'AlphabetDictationIndex',
        component: AlphabetDictationIndex
    },
    {
        path: '/dictation/alphabet/create',
        name: 'AlphabetDictationCreate',
        component: AlphabetDictationCreate
    },
    {
        path: '/dictation/alphabet/edit/:id',
        name: 'AlphabetDictationEdit',
        component: AlphabetDictationEdit
    },

    {
        path: '/machine-learning/tuning',
        name: 'admin.ml.tuning.index',
        component: MachineTuningIndex
    },
    {
        path: '/machine-learning/music-piece-builder',
        name: 'admin.ml.music-piece.builder',
        component: MusicPieceBuilder
    },




]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
